import {
    GridFilterInputValue,
    GridFilterOperator,
    getGridNumericOperators,
    getGridStringOperators,
} from '@mui/x-data-grid';

const STRING_NOT_EQUALS_OPERATOR: GridFilterOperator = {
    label: 'not equal',
    value: 'notEquals',
    getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) {
            return null;
        }

        const filterItemValue = filterItem.value.trim();
        const collator = new Intl.Collator(undefined, {
            sensitivity: 'base',
            usage: 'search',
        });

        return (value) => {
            return value != null ? collator.compare(filterItemValue, value.toString()) !== 0 : true;
        };
    },
    InputComponent: GridFilterInputValue,
};

const NUMERIC_CONTAINS_OPERATOR: GridFilterOperator = {
    label: 'contains',
    value: 'contains',
    getApplyFilterFn: (filterItem) => {
        if (filterItem.value === undefined || filterItem.value === null || filterItem.value === '') {
            return null;
        }

        return (value) => {
            return value != null ? String(value).includes(String(filterItem.value)) : false;
        };
    },
    InputComponent: GridFilterInputValue,
    InputComponentProps: {
        type: 'number',
    },
};

export const SERVER_STRING_FILTER_OPERATORS = [
    ...getGridStringOperators().filter((operator) =>
        ['contains', 'equals', 'isAnyOf'].includes(operator.value),
    ),
    STRING_NOT_EQUALS_OPERATOR,
];

export const SERVER_NUMERIC_FILTER_OPERATORS = [
    NUMERIC_CONTAINS_OPERATOR,
    ...getGridNumericOperators().filter((operator) => ['=', '!=', 'isAnyOf'].includes(operator.value)),
];
